import './contact.css';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Leeks from '../images/leeks.webp';


export default function Contact(){
    return(
        <div>
            <Image id="leeks" src={Leeks} alt="pink mushroom"/>

            <h1 id="contact-title">We’d Love to Hear From You! </h1>
            <h3 id="contact-subheader">Have a question about home delivery, market pickups, or wholesale orders for your restaurant? Reach out to us below!</h3>
            <Container>
               
                <a className="contact-anchor" href="tel: 520-486-1753" title="Call us">Phone: 520-486-1753</a>
                <a className="contact-anchor" href="mailto: support@holisticgreenthings.com" id="email-link">Email</a>
                <a className="contact-anchor" href="www.facebook.com/HolisticGreenThings">Facebook</a> 
                <a className="contact-anchor" href="www.instagram.com/HolisticGreenThings">Instagram</a>

                <p className="contact-paragraph">You can also find us at the <a href="https://rusticrootsfarmersmarket.com/">Rustic Roots Farmer's Market</a> on Fridays & Saturdays.</p>
            </Container>
            
           
        </div>
    )
}